/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type AvailableNotificationsResponseDisabled = { [key: string]: string[] };
